<!--
  Audit UI/UX (feedback utente su screenshot): l'accordion "piatto" preso da
  project-detail.component.html (pannelli senza ombra/bordo, appoggiati sul
  gradiente di sfondo di .accordion-container) stonava con le vere card bianche
  della dashboard sotto e della tab "Team" - risultato incoerente. Sostituito con
  le stesse card (.dashboard-card, header con icona+titolo+descrizione, body con
  padding) gia' usate ovunque in questa stessa tab, invece di un pattern preso da
  un'altra pagina.
-->
<div class="clinical-onboarding-management container-fluid mb-4">
  <div class="dashboard-card shadow-sm my-4 border-primary">
    <div class="card-header bg-white border-bottom p-4 card-header-top">
      <h4 class="dashboard-card-title text-primary-purple mb-1 d-flex align-items-center">
        <mat-icon class="dashboard-title-icon">settings</mat-icon>
        {{ 'components.clinical-onboarding.config.panel-title' | translate }}
      </h4>
      <p class="text-muted mb-0">{{ 'components.clinical-onboarding.config.description' | translate }}</p>
    </div>
    <div class="card-body p-4">
      <app-clinical-onboarding-config
        [surveyId]="surveyId"
        [config]="config"
        (configSaved)="onConfigSaved($event)"
      ></app-clinical-onboarding-config>
    </div>
  </div>

  @if (enabled) {
    <div class="dashboard-card shadow-sm my-4 border-primary">
      <div class="card-header bg-white border-bottom p-4 card-header-top">
        <h4 class="dashboard-card-title text-primary-purple mb-1 d-flex align-items-center">
          <mat-icon class="dashboard-title-icon">folder_shared</mat-icon>
          {{ 'components.clinical-onboarding.document-templates.panel-title' | translate }}
        </h4>
        <p class="text-muted mb-0">{{ 'components.clinical-onboarding.document-templates.description' | translate }}</p>
      </div>
      <div class="card-body p-4">
        <app-clinical-onboarding-document-templates [surveyId]="surveyId"></app-clinical-onboarding-document-templates>
      </div>
    </div>
  }

  @if (enabled) {
    <app-clinical-onboarding-dashboard [surveyId]="surveyId"></app-clinical-onboarding-dashboard>
  }
</div>
